import React from 'react';
import './LegalPages.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1>Datenschutzerklärung</h1>
          <p>Stand: 23. August 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Verantwortlicher</h2>
            <p>
              Verantwortlicher für die Datenverarbeitung auf dieser Website ist:<br/><br/>
              <strong>EFC Buseck e.V.</strong><br/>
              Hauptstraße 42<br/>
              35418 Buseck<br/>
              Deutschland<br/><br/>
              E-Mail: datenschutz@efc-buseck.de<br/>
              Telefon: +49 (0) 6408 123456
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>

            <h3>2.1 Registrierung</h3>
            <p>
              Bei der Registrierung auf unserer Website erheben wir folgende personenbezogene Daten:
            </p>
            <ul>
              <li>Vorname und Nachname</li>
              <li>E-Mail-Adresse</li>
              <li>Passwort (verschlüsselt gespeichert)</li>
              <li>Optional: Telefonnummer und Adresse</li>
            </ul>
            <p>
              Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO zur Erfüllung 
              des Vertrages bzw. zur Durchführung vorvertraglicher Maßnahmen.
            </p>

            <h3>2.2 Spielanmeldungen</h3>
            <p>
              Bei Anmeldungen zu Spielen verarbeiten wir zusätzlich:
            </p>
            <ul>
              <li>Gewählte Ticket-Art</li>
              <li>Optionale Nachrichten/Kommentare</li>
              <li>Anmeldedatum und -uhrzeit</li>
            </ul>
            <p>
              Diese Daten werden zur Organisation der Fahrten und Spiele benötigt.
            </p>

            <h3>2.3 Automatisch erhobene Daten</h3>
            <p>
              Beim Besuch unserer Website werden automatisch folgende Daten erhoben:
            </p>
            <ul>
              <li>IP-Adresse</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Aufgerufene Seiten</li>
              <li>Browser-Typ und -Version</li>
              <li>Betriebssystem</li>
            </ul>
            <p>
              Diese Daten werden zur technischen Bereitstellung der Website benötigt und nach 
              7 Tagen automatisch gelöscht.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Zwecke der Datenverarbeitung</h2>
            <p>Wir verarbeiten Ihre personenbezogenen Daten zu folgenden Zwecken:</p>
            <ul>
              <li>Bereitstellung und Verwaltung von Benutzerkonten</li>
              <li>Organisation von Spielanmeldungen und Fahrten</li>
              <li>Kommunikation mit unseren Mitgliedern</li>
              <li>Technische Bereitstellung der Website</li>
              <li>Erfüllung rechtlicher Verpflichtungen</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Weitergabe von Daten</h2>
            <p>
              Ihre personenbezogenen Daten werden nur in folgenden Fällen an Dritte weitergegeben:
            </p>
            <ul>
              <li>Mit Ihrer ausdrücklichen Einwilligung</li>
              <li>Zur Erfüllung rechtlicher Verpflichtungen</li>
              <li>An technische Dienstleister (z.B. Hosting-Provider) im Rahmen der Auftragsverarbeitung</li>
            </ul>
            <p>
              Bei Spielanmeldungen werden Ihre Kontaktdaten anderen Teilnehmern zur Organisation 
              gemeinsamer Fahrten zugänglich gemacht, sofern Sie dem zustimmen.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Speicherdauer</h2>
            <p>Wir speichern Ihre Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist:</p>
            <ul>
              <li>Benutzerkonto-Daten: bis zur Löschung des Kontos</li>
              <li>Anmeldedaten: bis zu 2 Jahre nach dem Spiel für statistische Zwecke</li>
              <li>E-Mail-Kommunikation: bis zu 3 Jahre</li>
              <li>Server-Logs: 7 Tage</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Ihre Rechte</h2>
            <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
            <ul>
              <li><strong>Auskunftsrecht (Art. 15 DSGVO):</strong> Sie können Auskunft über die von uns verarbeiteten personenbezogenen Daten verlangen.</li>
              <li><strong>Berichtigungsrecht (Art. 16 DSGVO):</strong> Sie können die Berichtigung unrichtiger oder die Vervollständigung unvollständiger Daten verlangen.</li>
              <li><strong>Löschungsrecht (Art. 17 DSGVO):</strong> Sie können die Löschung Ihrer personenbezogenen Daten verlangen.</li>
              <li><strong>Einschränkungsrecht (Art. 18 DSGVO):</strong> Sie können die Einschränkung der Verarbeitung verlangen.</li>
              <li><strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie können die Übertragung Ihrer Daten in einem strukturierten Format verlangen.</li>
              <li><strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie können der Verarbeitung Ihrer Daten widersprechen.</li>
            </ul>
            <p>
              Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: datenschutz@efc-buseck.de
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Sicherheit</h2>
            <p>
              Wir verwenden technische und organisatorische Maßnahmen, um Ihre Daten vor Verlust, 
              Manipulation und unbefugtem Zugriff zu schützen:
            </p>
            <ul>
              <li>SSL-Verschlüsselung für die Datenübertragung</li>
              <li>Verschlüsselte Speicherung von Passwörtern</li>
              <li>Regelmäßige Sicherheitsupdates</li>
              <li>Zugriffsbeschränkungen auf Serverdaten</li>
              <li>Regelmäßige Datensicherungen</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Cookies und lokale Speicherung</h2>
            <p>
              Unsere Website verwendet Cookies und lokale Speicherfunktionen für:
            </p>
            <ul>
              <li>Session-Management (erforderlich für die Funktionalität)</li>
              <li>Speicherung von Anmeldeinformationen (mit Ihrer Zustimmung)</li>
              <li>Benutzereinstellungen (mit Ihrer Zustimmung)</li>
            </ul>
            <p>
              Sie können Cookies in Ihren Browser-Einstellungen deaktivieren, wodurch jedoch 
              die Funktionalität der Website eingeschränkt werden kann.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. E-Mail-Kommunikation</h2>
            <p>
              Wir senden E-Mails für folgende Zwecke:
            </p>
            <ul>
              <li>Bestätigung der Registrierung und E-Mail-Verifizierung</li>
              <li>Benachrichtigungen über Spielanmeldungen</li>
              <li>Wichtige Vereinsinformationen</li>
              <li>Antworten auf Ihre Anfragen</li>
            </ul>
            <p>
              Sie können sich jederzeit von nicht-essentiellen E-Mails abmelden, indem Sie 
              den Abmeldelink in der E-Mail verwenden oder uns unter datenschutz@efc-buseck.de kontaktieren.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Kinder und Jugendliche</h2>
            <p>
              Unsere Website richtet sich nicht gezielt an Personen unter 16 Jahren. 
              Sollten wir erfahren, dass wir personenbezogene Daten von Kindern unter 16 Jahren 
              ohne Einverständnis der Eltern gesammelt haben, werden wir diese Daten löschen.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Beschwerderecht</h2>
            <p>
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über unsere 
              Verarbeitung personenbezogener Daten zu beschweren. Die für uns zuständige 
              Aufsichtsbehörde ist:
            </p>
            <p>
              <strong>Hessischer Beauftragter für Datenschutz und Informationsfreiheit</strong><br/>
              Postfach 3163<br/>
              65021 Wiesbaden<br/>
              E-Mail: poststelle@datenschutz.hessen.de
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Änderungen dieser Datenschutzerklärung</h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung zu ändern, um sie an geänderte 
              Rechtslagen oder bei Änderungen unserer Dienstleistungen anzupassen. 
              Die aktuelle Datenschutzerklärung ist stets unter /datenschutz abrufbar.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Kontakt</h2>
            <p>
              Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:
            </p>
            <p>
              <strong>EFC Buseck e.V.</strong><br/>
              Datenschutzbeauftragter<br/>
              E-Mail: datenschutz@efc-buseck.de<br/>
              Telefon: +49 (0) 6408 123456
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
